module.exports = __webpack_public_path__ + "img/no-image2.e8b4eb4b.png";